import React from 'react'
import SideNav from './SideNav'

const KidsRoomDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-kids-room-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Kids Room Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/kids-room-designs.jpg" alt="Kids Room Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Every child deserves a space that sparks imagination and feels like their own little world. 
                      At <b>MeHome</b>, we design kids’ rooms that blend creativity with comfort — colorful, inspiring, and built for growing minds.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Spaces <span>That Grow With Your Child</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      From themed walls and playful furniture to functional study zones and storage, 
                      we create personalized environments that encourage exploration and learning 
                      while maintaining safety and simplicity.
                    </p>

                    <ul>
                      <li>Custom furniture designed for comfort, creativity, and easy use.</li>
                      <li>Child-safe materials and rounded-edge designs.</li>
                      <li>Dedicated study, play, and sleep zones for balanced living.</li>
                      <li>Modular furniture that adapts as kids grow older.</li>
                      <li>Thoughtful use of color, texture, and lighting to inspire joy.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Creative <span>Kids Room Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Themed Bedrooms</h3>
                          <p>
                            From princess castles to superhero hideouts — imaginative themes that bring joy, 
                            excitement, and personality to every corner.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">📚</div>
                        <div className="why-choose-item-content">
                          <h3>Study Corners</h3>
                          <p>
                            Ergonomic desks, good lighting, and creative shelving that make studying enjoyable 
                            and promote focus in young learners.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🧺</div>
                        <div className="why-choose-item-content">
                          <h3>Smart Storage</h3>
                          <p>
                            Built-in drawers, hidden compartments, and toy organizers to keep everything 
                            tidy without compromising design appeal.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🌈</div>
                        <div className="why-choose-item-content">
                          <h3>Colorful Interiors</h3>
                          <p>
                            Soft, vibrant, and psychologically balanced color themes that encourage positivity, 
                            creativity, and a sense of calm.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🪵</div>
                        <div className="why-choose-item-content">
                          <h3>Convertible Furniture</h3>
                          <p>
                            Smart, adaptable beds and desks that grow with your child, ensuring long-term comfort and value.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Parents Choose <span> MeHome</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Safety First:</b> Non-toxic paints, safe materials, and child-friendly finishes.</li>
                        <li><b>Personalization:</b> Every design tailored to your child’s personality and interests.</li>
                        <li><b>Smart Functionality:</b> Combining creativity with everyday usability.</li>
                        <li><b>Enduring Quality:</b> Long-lasting furniture built with care and precision.</li>
                        <li><b>Holistic Approach:</b> Designs that nurture creativity, focus, and happiness.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default KidsRoomDesigns
